import React from 'react';
// import QueueAnim from 'rc-queue-anim';
// import TweenOne from 'rc-tween-one';
/* replace-start-value = import { getChildrenToRender } from './utils'; */
import { getChildrenToRender } from '../../utils';
/* replace-end-value */
/* replace-start */
import './index.less';
/* replace-end */
class Feature99 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getHtml(data) {
      return data.map((item, index) => {
        return (
          <div {...item} key={item.name + index}>
            {
              item.children.map(getChildrenToRender)
            }
          </div>
        );
      });
    }

    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div
          {...dataSource.page}
        >
          <div {...dataSource.content}>
            <div {...dataSource.content.left}>
              <div {...dataSource.content.left.title}>
                { dataSource.content.left.title.children.map(getChildrenToRender) }
              </div>
              <div {...dataSource.content.left.box}>
                { getHtml(dataSource.content.left.box.children) }
              </div>
            </div>
            <div {...dataSource.content.right}>
              { dataSource.content.right.children.map(getChildrenToRender) }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Feature99;
